import {
    IonButton,
    IonItemDivider,
    IonItemGroup,
    IonLabel,
} from '@ionic/react';
import { Trans, t } from '@lingui/macro';
import { useAtom } from 'jotai';
import React, { memo, useCallback } from 'react';

import LoadableContent from '../../components/content/LoadableContent';
import InterventionPage from '../../components/page/InterventionPage';
import PhotoUpload from '../../components/photoUpload/PhotoUpload';
import { IRoomWithDevices } from '../../interfaces/IOdooRoomsResponse';
import { IInstallationRouteProps } from '../../interfaces/IRoute';
import { roomsWithDevicesAndStateAtom } from '../../store/Atoms';
import { ImageCategories } from '../../types/ImageInfo';
import { MAX_IMAGE_NR } from '../../utils/constants';
import { useCustomRouter } from '../../utils/hooks/useCustomRouter';
import usePhotosUploaded from '../../utils/hooks/usePhotosUploaded';

const Inventory: React.FC<IInstallationRouteProps> = memo(({ match }) => {
    const router = useCustomRouter();
    const [value] = useAtom(roomsWithDevicesAndStateAtom);

    const rooms = value.state === 'hasData' ? value.data : [];
    const photosUploaded = usePhotosUploaded();
    const canProceed = photosUploaded;

    const onProceedHandler = useCallback(async () => {
        router.push('confirm', 'forward', 'push');
    }, [router]);

    return (
        <InterventionPage title={t`Inventory`}>
            <LoadableContent value={value}>
                {rooms.map((room: IRoomWithDevices) =>
                    room.devices.map((device, index) => (
                        <IonItemGroup key={device.macAddress}>
                            <IonItemDivider color="primary">
                                <IonLabel>{device.macAddress}</IonLabel>
                            </IonItemDivider>
                            <div className="ion-padding-start ion-padding-end ion-margin-top ion-margin-bottom">
                                <PhotoUpload
                                    maxNumber={MAX_IMAGE_NR}
                                    imageCode={`${ImageCategories.dboxFront}_${device.macAddress}`}
                                    label={t`DBOX Front`}
                                />
                                <PhotoUpload
                                    maxNumber={MAX_IMAGE_NR}
                                    imageCode={`${ImageCategories.dboxBack}_${device.macAddress}`}
                                    label={t`DBOX Back`}
                                />
                            </div>
                        </IonItemGroup>
                    ))
                )}
                <div className="ion-padding">
                    <IonButton
                        expand="block"
                        onClick={onProceedHandler}
                        disabled={!canProceed}
                    >
                        <Trans>Proceed</Trans>
                    </IonButton>
                </div>
            </LoadableContent>
        </InterventionPage>
    );
});

export default Inventory;
